import type { GtmEventData } from '@/shared/lib/googleTag'
import type { ContactFormPayload } from './contactFormSchema'

export function createLeadFormTrackingPayload(payload: ContactFormPayload): GtmEventData {
  return {
    company_provided: payload.company.trim().length > 0,
    email_provided: payload.email.trim().length > 0,
    form_location: 'contact_page',
    form_name: 'contact',
    message_length_bucket: getMessageLengthBucket(payload.message.length),
    message_provided: payload.message.trim().length > 0,
    name_provided: payload.name.trim().length > 0,
    reason: payload.reason,
    reason_provided: payload.reason.trim().length > 0,
    time_to_submit_seconds: getTimeToSubmitSeconds(payload.startedAt),
  }
}

function getMessageLengthBucket(messageLength: number) {
  if (messageLength < 250) {
    return 'short'
  }

  if (messageLength < 1_000) {
    return 'medium'
  }

  return 'long'
}

function getTimeToSubmitSeconds(startedAt: number) {
  return Math.max(0, Math.round((Date.now() - startedAt) / 1_000))
}
